<template>
    <div>
        <v-container grid-list-xl fluid fill-height>
            <v-layout row wrap :justify-center="$bp.xs">
                <!-- <v-flex style="flex-grow: 0; flex-basis: 0">
                    <v-card tile height="200" width="250" class="text-xs-center elevation-10 clickable" @mouseup.left="showEmail()">
                        <v-icon color="primary" style="margin-top: 82px" size="36">add</v-icon>
                    </v-card>
                </v-flex> -->
                <v-flex v-for="(email, index) in emails" :key="index" style="flex-grow: 0; flex-basis: 0">
                    <v-card
                        v-if="email.email_address.length < 24"
                        height="125"
                        width="175"
                        class="subheading text-xs-center py-3 elevation-2 clickable"
                        @mouseup.left="showEmail(email)"
                    >
                        <!-- <v-icon size="36" fill-height color="primary">mail</v-icon> -->
                        <v-flex class="pa-1 fs-14">{{ $textTruncate(email.email_address, 24) }}</v-flex>
                        <v-flex class="pa-0 fs-12">{{ $t(`lang.${email.email_type}`) }}</v-flex>
                        <v-chip color="primary" class="my-2 pa-1 body-2 white--text" small v-if="email.prime == true" disabled>{{
                            $t("lang.primary_caps")
                        }}</v-chip>
                    </v-card>
                    <bc-tooltip v-else>
                        <template slot="activator">
                            <v-card height="125" width="175" class="subheading text-xs-center py-3 elevation-2 clickable" @mouseup.left="showEmail(email)">
                                <!-- <v-icon size="36" fill-height color="primary">mail</v-icon> -->
                                <v-flex class="pa-1 fs-14">{{ $textTruncate(email.email_address, 24) }}</v-flex>
                                <v-flex class="pa-0 fs-12">{{ $t(`lang.${email.email_type}`) }}</v-flex>
                                <v-chip color="primary" class="my-2 pa-1 body-2 white--text" small v-if="email.prime == true" disabled>{{
                                    $t("lang.primary_caps")
                                }}</v-chip>
                            </v-card>
                        </template>
                        {{ email.email_address }}
                    </bc-tooltip>
                </v-flex>
            </v-layout>
        </v-container>
        <bc-email-dialog
            :send_email="send_email ? send_email : null"
            ref="emailDialog"
            :getFunction="getFunction"
            entity_object="me"
            :total_items="emails ? emails : null"
        ></bc-email-dialog>
    </div>
</template>

<script>
export default {
    props: ["emails", "getFunction", "send_email"],
    methods: {
        showEmail(email = null) {
            this.$refs.emailDialog.showEmail(email);
        },
    },
};
</script>
